// Types and Interfaces
interface MilitaryBannerConfig {
  backgroundColor: string;
  logo: {
    src: string;
    alt: string;
    width: number;
  };
  message: string;
}

// Constants
const MILITARY_BANNER_CONFIG: MilitaryBannerConfig = {
  backgroundColor: "#153550",
  logo: {
    src: "https://assets.thdstatic.com/images/v1/military-banner-logo.svg",
    alt: "Military service appreciation logo",
    width: 51,
  },
  message: "Military Discount Verified - Thank you for your service.",
};

export type { MilitaryBannerConfig };
export { MILITARY_BANNER_CONFIG };
